var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClientUploadSuccessV2 = function SvgClientUploadSuccessV2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-27{isolation:isolate;}.cls-2{fill:#ebebeb;}.cls-3{fill:#4e4c4d;}.cls-4{fill:#263238;}.cls-5{fill:#5e80e6;}.cls-6{fill:#f5f5f5;}.cls-7{fill:#fafafa;}.cls-10,.cls-8{fill:#66cb94;}.cls-9{fill:#fff;}.cls-10{font-size:14.92px;font-family:Poppins-Medium, Poppins;font-weight:500;}.cls-11,.cls-19{fill:#a9c4fc;}.cls-11,.cls-12,.cls-16{opacity:0.9;}.cls-12,.cls-16{fill:#dee7fd;}.cls-13{fill:#1b5998;}.cls-14{fill:#577afa;}.cls-15{fill:#718096;}.cls-16,.cls-19{mix-blend-mode:multiply;}.cls-17{fill:#f2f2f2;}.cls-18{fill:#8d99ab;}.cls-19{opacity:0.7;}.cls-20{fill:#aab3c0;}.cls-21{fill:#b97964;}.cls-22{fill:#e9edfc;}.cls-23{fill:#adbcea;}.cls-24{fill:#a76755;}.cls-25{fill:#182137;}.cls-26{fill:#a24e3f;}.cls-27{opacity:0.4;}.cls-28{fill:none;stroke:#e9edfc;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 375,
    cy: 441.86,
    rx: 356.31,
    ry: 25.68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 254.69,
    y: 172.38,
    width: 399.04,
    height: 263.88,
    rx: 14.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.09,419.22H671.42a0,0,0,0,1,0,0v5.29a17.8,17.8,0,0,1-17.8,17.8H256.89a17.8,17.8,0,0,1-17.8-17.8v-5.29A0,0,0,0,1,239.09,419.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 265.4,
    y: 182.86,
    width: 376.5,
    height: 222.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "414.87 416.74 420.23 425.27 495.72 425.27 500.7 416.74 414.87 416.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.15,
    y: 190.41,
    width: 361.76,
    height: 214.59,
    rx: 3.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "634.53 405.31 272.76 405.31 273.15 206.44 634.53 206.44 634.53 405.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M302.82,198.69a2.89,2.89,0,1,1-2.89-2.89A2.89,2.89,0,0,1,302.82,198.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285.31,198.69a2.89,2.89,0,1,1-2.89-2.89A2.89,2.89,0,0,1,285.31,198.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M293.72,198.69a2.89,2.89,0,1,1-2.89-2.89A2.89,2.89,0,0,1,293.72,198.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M650.29,416.74c0,.14-88.56.26-197.79.26s-197.81-.12-197.81-.26,88.54-.26,197.81-.26S650.29,416.6,650.29,416.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M536.83,384.16H377.13V373.82h159.7Zm-159.1-.61h158.5v-9.13H377.73Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "534.07 381.98 379.86 381.98 379.86 376 534.07 376"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 409.42,
    cy: 351.71,
    r: 9.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "409.56 357.01 404.14 351.52 405.96 349.72 409.13 352.93 415.71 342.61 417.87 343.99 409.56 357.01"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(426.43 357.13)"
  }, "UPLOADED")), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M463,275.62h0a3.57,3.57,0,0,1,3.2-2.24h26.7a2.38,2.38,0,0,1,2.41,2.89l-8.44,50.42a3.56,3.56,0,0,1-3.38,2.9H416.58a2.39,2.39,0,0,1-2.41-2.9l7.18-42.92a3.56,3.56,0,0,1,3.38-2.89h30.82A8.35,8.35,0,0,0,463,275.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M452.4,230.86l-20.19,70.19,46.2,13.3,20.2-70.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 461.6,
    cy: 247.48,
    r: 8.33,
    transform: "translate(-28.55 432.06) rotate(-48.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459.77,253.82a6.6,6.6,0,1,1,8.17-4.52A6.61,6.61,0,0,1,459.77,253.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 449.33,
    y: 258.59,
    width: 15.3,
    height: 3.44,
    transform: "translate(89.8 -116.22) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 440.08,
    y: 285.27,
    width: 8.44,
    height: 13.37,
    transform: "translate(98.06 -111.48) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 468.77,
    y: 293.52,
    width: 8.44,
    height: 13.37,
    transform: "translate(101.46 -119.09) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 454.43,
    y: 289.4,
    width: 8.44,
    height: 13.37,
    transform: "translate(99.76 -115.28) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 466.07,
    y: 262.7,
    width: 10.35,
    height: 3.44,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 91.5, -120)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 447.1,
    y: 268.93,
    width: 37.88,
    height: 1.42,
    transform: "translate(92.74 -118.36) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 446.64,
    y: 269.19,
    width: 18.84,
    height: 1.42,
    transform: "translate(92.42 -115.59) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 467.96,
    y: 274.43,
    width: 12.6,
    height: 1.42,
    transform: "translate(94.58 -120.42) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 445.58,
    y: 273.67,
    width: 30.28,
    height: 1.42,
    transform: "translate(93.84 -116.7) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 444.66,
    y: 277.19,
    width: 34.81,
    height: 1.42,
    transform: "translate(94.87 -116.94) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 444.43,
    y: 275.83,
    width: 4.02,
    height: 1.42,
    transform: "translate(93.88 -112.67) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 451.13,
    y: 279.73,
    width: 17.77,
    height: 1.42,
    transform: "translate(95.49 -116.27) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 442.94,
    y: 283.4,
    width: 37.88,
    height: 1.42,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 96.58, -116.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M451.51,234l-19.3,67.08,44.63,12.84,18.09-69.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M447,233.3l-17.76,70.85,46.64,11.69L493.67,245Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 456.79,
    cy: 249.6,
    r: 8.33,
    transform: "translate(-63.09 223.47) rotate(-25.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 456.79,
    cy: 249.6,
    r: 6.6,
    transform: "translate(129.02 653.98) rotate(-79.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 444.97,
    y: 260.86,
    width: 15.3,
    height: 3.44,
    transform: "translate(77.42 -102.17) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 436.82,
    y: 287.96,
    width: 8.44,
    height: 13.37,
    transform: "translate(84.87 -98.39) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 465.78,
    y: 295.22,
    width: 8.44,
    height: 13.37,
    transform: "translate(87.5 -105.21) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 451.3,
    y: 291.59,
    width: 8.44,
    height: 13.37,
    transform: "translate(86.19 -101.8) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 461.84,
    y: 264.47,
    width: 10.35,
    height: 3.44,
    transform: "translate(78.73 -105.56) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 443.06,
    y: 270.88,
    width: 37.88,
    height: 1.42,
    transform: "translate(79.9 -104.18) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 442.61,
    y: 271.49,
    width: 18.84,
    height: 1.42,
    transform: "translate(79.74 -101.73) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 464.1,
    y: 276.1,
    width: 12.6,
    height: 1.42,
    transform: "translate(81.42 -106.06) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 441.71,
    y: 275.8,
    width: 30.28,
    height: 1.42,
    transform: "translate(80.94 -102.78) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 440.91,
    y: 279.27,
    width: 34.81,
    height: 1.42,
    transform: "translate(81.83 -103.03) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 440.64,
    y: 278.45,
    width: 4.02,
    height: 1.42,
    transform: "translate(81.15 -99.24) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 447.46,
    y: 281.89,
    width: 17.77,
    height: 1.42,
    transform: "translate(82.4 -102.47) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 439.4,
    y: 285.49,
    width: 37.88,
    height: 1.42,
    transform: "translate(83.34 -102.85) rotate(14.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M445.2,286.15h0a2.18,2.18,0,0,1,2.4-1.94h26.7a3.55,3.55,0,0,1,3.44,2.5l8,40.38c.3,1.38-.75,2.5-2.35,2.5H416.46a3.55,3.55,0,0,1-3.44-2.5l-6.6-33.91c-.3-1.38.75-2.5,2.35-2.5H439.6C442.75,290.68,445.07,288.8,445.2,286.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Documents"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299.05,144.68Q293.52,115,288,86c-24.56,2.91-48.95,15.76-73.55,15.52Q220,131.2,225.5,160.2C250.05,157.29,274.44,144.45,299.05,144.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M226.39,106.22q3.06,16.08,6.13,32l1.89-.38q-3.07-15.9-6.13-31.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M231.16,105.45q3.06,16,6.13,31.79l1.88-.44q-3.06-15.81-6.12-31.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M235.92,104.48l6.13,31.61,1.89-.49q-3.06-15.73-6.13-31.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M240.69,103.35q4.49,23.12,9,46.06l1.89-.54q-4.49-23-9-46C242,103,241.32,103.2,240.69,103.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M245.45,102.1q4.49,23,9,45.94l1.89-.56q-4.49-22.92-9-45.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M250.21,100.76q4.48,23,9,45.88l1.89-.55-9-45.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M255,99.38q4.48,22.94,9,45.88l1.89-.54q-4.49-23-9-45.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M259.73,98l9,46,1.88-.5q-4.48-23.07-9-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M264.5,96.61q4.49,23,9,46.08c.63-.15,1.26-.31,1.89-.45q-4.5-23.18-9-46.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M269.26,95.31q4.49,23,9,46.27l1.89-.39q-4.49-23.31-9-46.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274,94.1q4.49,23.16,9,46.54l1.89-.32q-4.49-23.47-9-46.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M278.79,93q4.48,23.28,9,46.87c.63-.09,1.26-.16,1.89-.23q-4.49-23.68-9-47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M289.81,122.11,289.12,174c27.66,26.91,55.33-18.17,83,7.86l.51-38.51a100.51,100.51,0,0,0-15.63-22C334.59,117.36,312.2,142.93,289.81,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M372.62,143.32a100.51,100.51,0,0,0-15.63-22l-.18,13.49C362.08,135.68,367.35,138.19,372.62,143.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M358.25,169q.19-14.56.38-29.11c-.71-.17-1.42-.32-2.13-.43q-.18,14.58-.38,29.14C356.83,168.66,357.54,168.79,358.25,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M352.87,168.28l.39-29.18c-.71,0-1.42,0-2.14,0q-.18,14.6-.38,29.21C351.45,168.27,352.16,168.26,352.87,168.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M347.49,168.58l.39-29.25c-.71.08-1.42.19-2.13.31l-.39,29.27Q346.42,168.72,347.49,168.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M342.11,169.59l.57-42.91c-.71.16-1.42.34-2.13.53L340,170.14C340.69,170,341.4,169.76,342.11,169.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M336.74,171.1q.27-21.48.56-43l-2.13.67q-.29,21.48-.56,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M331.36,172.86q.28-21.5.56-43l-2.13.71q-.29,21.5-.56,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M326,174.64q.28-21.48.56-43l-2.13.67q-.29,21.47-.56,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M320.6,176.21q.28-21.47.56-42.93c-.71.19-1.42.36-2.13.53q-.28,21.45-.56,42.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M315.22,177.33q.28-21.44.56-42.87l-2.13.3q-.27,21.42-.56,42.84Q314.16,177.5,315.22,177.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M309.84,177.77l.57-42.79q-1.07,0-2.13,0l-.57,42.76Q308.78,177.77,309.84,177.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M304.47,177.3q.27-21.35.56-42.69c-.71-.11-1.42-.26-2.13-.44l-.57,42.64C303,177,303.76,177.16,304.47,177.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M299.09,175.68q.27-21.27.56-42.55c-.71-.29-1.42-.6-2.13-1q-.28,21.26-.56,42.5C297.67,175,298.38,175.38,299.09,175.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M379.06,162q-15.46,24.55-31.34,49.82c32.45-13,26.83,41.72,55.94,34.65l20-31.25,7.38-11C399.71,215.13,407,157.28,379.06,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M394.17,241.43l21.45-33.33a15.27,15.27,0,0,1-1.5-.78l-21.41,33.27A14.13,14.13,0,0,0,394.17,241.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M390.64,239q10.71-16.65,21.37-33.2c-.44-.37-.87-.76-1.28-1.17l-21.36,33.18C389.78,238.25,390.2,238.65,390.64,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M387.56,235.81q10.71-16.67,21.36-33.18c-.38-.48-.75-1-1.1-1.48q-10.67,16.53-21.38,33.2C386.8,234.85,387.18,235.34,387.56,235.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M384.82,232q10.77-16.76,21.45-33.34c-.33-.56-.66-1.13-1-1.71L383.8,230.35C384.13,230.91,384.47,231.45,384.82,232Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M382.3,227.78q10.83-16.87,21.57-33.56c-.3-.6-.6-1.22-.9-1.84l-21.64,33.67C381.65,226.63,382,227.21,382.3,227.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M379.87,223.39l21.77-33.89-.87-1.9q-10.86,16.91-21.86,34.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M377.43,219l22-34.34c-.29-.63-.58-1.26-.88-1.88l-22.14,34.55C376.77,217.92,377.1,218.48,377.43,219Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M374.85,214.93q11.25-17.6,22.34-34.9c-.31-.6-.62-1.19-.94-1.77q-11.16,17.43-22.49,35.16C374.13,213.91,374.5,214.42,374.85,214.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M372,211.29q11.46-18,22.73-35.6c-.34-.54-.69-1.06-1.05-1.57Q382.34,191.9,370.79,210C371.21,210.42,371.62,210.84,372,211.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M368.8,208.31q11.68-18.37,23.18-36.4c-.39-.45-.8-.89-1.21-1.3L367.4,207.36A16.4,16.4,0,0,1,368.8,208.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365.09,206.21q12-18.86,23.7-37.32c-.46-.34-.93-.65-1.41-.94q-11.85,18.66-23.92,37.72A14.82,14.82,0,0,1,365.09,206.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M360.77,205.2q12.25-19.38,24.28-38.36a15.13,15.13,0,0,0-1.66-.49q-12.15,19.18-24.53,38.8A17.14,17.14,0,0,1,360.77,205.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "97.05 416.54 104.36 423.08 118.27 408.6 110.96 402.06 97.05 416.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "122.08 430.16 131.3 430.16 132.5 408.81 123.28 408.81 122.08 430.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.78,429.09H121.43a.66.66,0,0,0-.69.63l-.5,8.2a1.64,1.64,0,0,0,1.61,1.64c3.61-.07,5.33-.28,9.89-.28,2.8,0,14.71.29,18.58.29s3.76-3.82,2.12-4.17c-7.35-1.55-16.47-3.7-19.07-5.74A2.58,2.58,0,0,0,131.78,429.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.37,420.46l-8.88-6a.82.82,0,0,0-1,0l-6.79,6.85a1.36,1.36,0,0,0,.33,2.08c5.66,4.36,9.76,7.66,13,11.29,3.77,4.24,5.75,4.84,14.45,4.84,4,0,6.31-3.39,4.67-3.91-14.51-4.59-10.63-6.59-14.16-13.32A4.89,4.89,0,0,0,106.37,420.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M166.59,124c.17.54.45,1.37.7,2.08l.8,2.22c.55,1.48,1.15,2.95,1.78,4.4a86.61,86.61,0,0,0,4.18,8.41c3.06,5.35,6.77,10.19,11.15,13.29l.77.53s0,0,0,0,0,.09.18.11a5.05,5.05,0,0,0,2.4-.65,31.34,31.34,0,0,0,7-5.06c2.34-2.11,4.6-4.48,6.82-6.93s4.39-5.06,6.45-7.59l5.92,3.58a88.1,88.1,0,0,1-11.52,18.26,38.64,38.64,0,0,1-8.84,8,17.58,17.58,0,0,1-7.25,2.65,12.79,12.79,0,0,1-4.9-.45,13.67,13.67,0,0,1-2.37-1l-1.42-.81a40.89,40.89,0,0,1-9.35-7.71,59.3,59.3,0,0,1-6.91-9.2,77.91,77.91,0,0,1-5.19-9.9c-.74-1.69-1.42-3.4-2.06-5.14-.32-.87-.64-1.74-.93-2.63s-.54-1.72-.84-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M179.45,146l-15.9,8.8s-.48-.68-1.25-1.86c-.56-.87-1.28-2-2.11-3.36-4.68-7.6-12.41-21.48-10.41-27.31,3.1-9,14.51-8.9,20.12,1.59a163.71,163.71,0,0,1,7.28,16.1c.58,1.46,1.07,2.74,1.44,3.74C179.15,145.14,179.45,146,179.45,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M178.62,143.7l-16.32,9.24c-.56-.87-1.28-2-2.11-3.36l17-9.62C177.76,141.42,178.25,142.7,178.62,143.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M149.54,123.31c3.56-1.71,7.66-.28,12,6.53s8,18.2,8.39,21.45l-6.36,3.52S148.23,132.38,149.54,123.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M207.73,136.4l3.18-10.13,8.23,6s-4.5,9-7.55,8.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "219.58 122.38 224.22 128.06 219.14 132.3 210.91 126.27 219.58 122.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "118.26 408.6 111.09 416.07 103.78 409.53 110.95 402.06 118.26 408.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "123.28 408.81 132.5 408.81 131.88 419.82 122.65 419.82 123.28 408.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M164.29,196.12H115c-.34-4.41.68-18.73-.08-37a234.3,234.3,0,0,0-4.9-40.21c-.23-1-.45-2-.69-3,0,0,2.5-.51,6.08-1,3-.43,6.71-.88,10.36-1.06a187.76,187.76,0,0,1,21,0c3.22.3,6.37.84,8.88,1.32,3.21.65,5.4,1.25,5.4,1.25S172.84,144.27,164.29,196.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M114.9,159.15a234.41,234.41,0,0,0-4.9-40.22c3.29-.29,8.93,0,9.86,5.36C120.87,130,119.6,143.47,114.9,159.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.82,195.64s9.71,67.23,13,103.83C179.51,328.82,116,416.4,116,416.4l-12.28-11.55s46.37-78.49,42.8-111.17c-3.45-31.65-15.18-98-15.18-98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M146.54,293.68c-1.78-16.3-5.76-41.85-9.18-62.76,1.79-3.51,6.81-10.61,6.81-10.61,4.5,15.56,14.29,74.2.33,153.41C130,397.17,116,416.4,116,416.4l-1.9-30.25C127.56,360.86,149,316.3,146.54,293.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.29,195.64s.87,70.46-.62,96.86c-1.64,28.9-9.84,124.66-9.84,124.66H119s.5-93.42-.52-122c-1.1-31.06-4-99.48-4-99.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M118.25,129.34l-2.18,3.78q-1.11,1.94-2.16,3.92-2.13,3.94-4.09,8c-1.27,2.67-2.5,5.36-3.59,8a82.62,82.62,0,0,0-2.8,8.09l-.15.5-.07.26,0,.05s0,.11-.07.23a4.81,4.81,0,0,0,0,1.15,17.64,17.64,0,0,0,.73,3.46,59.7,59.7,0,0,0,3.15,7.89c2.51,5.33,5.51,10.78,8.53,16L110.07,195a104.91,104.91,0,0,1-12.29-15.08,59.94,59.94,0,0,1-5-9A30,30,0,0,1,91,165.37a18.4,18.4,0,0,1-.38-3.51,14.38,14.38,0,0,1,.16-2.1l.09-.52.06-.32.13-.63a91.39,91.39,0,0,1,6.16-19.08c1.31-3,2.74-5.94,4.27-8.82q1.14-2.16,2.37-4.27c.81-1.44,1.63-2.77,2.6-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M121.55,132.74a172.38,172.38,0,0,1-8,18.72c-.65,1.37-1.26,2.59-1.76,3.57-.87,1.73-1.42,2.77-1.42,2.77L91.69,147.45s.24-.78.66-2.1c.32-1,.75-2.3,1.27-3.8,3.11-8.87,9.46-24.69,15.69-25.6C118.63,114.6,125.33,121.56,121.55,132.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M113.55,151.46c-.65,1.37-1.26,2.59-1.76,3.57l-19.44-9.68c.32-1,.75-2.3,1.27-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M155.23,121c-1,3.3-3.78,7.7-11.38,10l-2,.6-2-.36c-15.61-2.8-21.35-11.17-22.35-12.83l-2.09-3.48c3-.43,6.71-.88,10.36-1.06a187.76,187.76,0,0,1,21,0c3.22.3,6.37.84,8.88,1.32A12.83,12.83,0,0,1,155.23,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M141.36,122.65c-12.5-2.24-16.41-8.74-16.41-8.74,4.56-4.5,2.81-16.8,1.25-23.55L131.81,95l7.64,6.34a24.45,24.45,0,0,0-.49,3.09c-.41,4.14.66,7.91,6.75,9.35C145.71,113.79,150.76,119.86,141.36,122.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M139.45,101.35a24.45,24.45,0,0,0-.49,3.09c-2.85-.57-6.65-3.61-7.05-6.52a13.49,13.49,0,0,1-.1-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.63,66.8c4.54,2,7.07,14.86,1.29,17.61S136,62.91,144.63,66.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M123.89,80.65c2,9,2.63,14.29,7.93,18.39a11.93,11.93,0,0,0,19.29-8.59c.7-8.35-2.6-21.61-12-24.14A12.06,12.06,0,0,0,123.89,80.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M121.82,90a9.86,9.86,0,0,0,5.69,3.39c2.83.48,3.47-2.14,2-4.67-1.29-2.28-4.32-5.27-6.85-4.6S120,87.8,121.82,90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138,81.54c.12.73.6,1.28,1.08,1.23s.79-.7.67-1.44-.59-1.29-1.08-1.23S137.92,80.8,138,81.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.38,80.55c.11.73.6,1.28,1.08,1.22s.78-.7.67-1.43-.6-1.29-1.08-1.23S146.27,79.81,146.38,80.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M143.78,81.23a28.09,28.09,0,0,0,4.5,5.87c-1.12,1.37-3.42,1.08-3.42,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.14,90.52a6.38,6.38,0,0,1-4.64-1.92.21.21,0,0,1,0-.3.21.21,0,0,1,.31,0A6.15,6.15,0,0,0,143,90a.22.22,0,0,1,0,.43A6.58,6.58,0,0,1,142.14,90.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135,79.16a.5.5,0,0,1-.21,0,.44.44,0,0,1-.17-.6,4.2,4.2,0,0,1,3.26-2.21.44.44,0,0,1,.05.87h0a3.36,3.36,0,0,0-2.55,1.77A.44.44,0,0,1,135,79.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.53,77.26a.44.44,0,0,1-.36-.19,3.67,3.67,0,0,0-2.76-1.67A.44.44,0,0,1,146,75a.44.44,0,0,1,.44-.43,4.43,4.43,0,0,1,3.48,2,.43.43,0,0,1-.12.6A.37.37,0,0,1,149.53,77.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M113.06,188.66l9.18-1.6-4.71,10.62s-8.38-.05-8-4.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "129.09 192.4 124.78 200.98 117.53 197.68 122.24 187.06 129.09 192.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M125.71,81.25c-.4.11-.43,1.9,0,3.52L125,85a11.39,11.39,0,0,1-1.72-3.71c-.89-3.38-1-5.58-.68-7.28l5.69-.74.23,1.84a1.37,1.37,0,0,0-.69,1.74,5,5,0,0,1-1.47,4.93S126.29,81.08,125.71,81.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M125.71,81.25c-.4.11-.43,1.9,0,3.52L125,85a11.39,11.39,0,0,1-1.72-3.71c-.89-3.38-1-5.58-.68-7.28l5.69-.74.23,1.84a1.37,1.37,0,0,0-.69,1.74,5,5,0,0,1-1.47,4.93S126.29,81.08,125.71,81.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.51,67.47s-1.45-2.58,1.62-5.57,16.06-4.09,20-1.54,7.08.74,6.86-.9a3.14,3.14,0,0,1,.26,3.5s2.49-.1,3.75,3.8a3,3,0,0,0-2.56.72,4.28,4.28,0,0,1,1.06,3.79,4.84,4.84,0,0,0-2.86-1.49,8.8,8.8,0,0,0,1.48,2.65S146,73,143.25,70.9a7.93,7.93,0,0,0,2.09,2.38s-8.39,1.51-11.17-2a5.25,5.25,0,0,0-.78,4.23s-2.58,0-3.79-1.66c0,0-3.24,2.88-7.06,3a9.22,9.22,0,0,0,1.15-1.69s-4.26,2.56-7.1.55a5.54,5.54,0,0,0,.69-2.07l-1.11.57S116,67.65,121.51,67.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M105.06,426c.93-.24,2.1-.67,3.91-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M106,428.45c.93-.23,2.1-.67,3.92-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M132.8,432.64c.9-.36,2.11-.73,2.58-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M134.7,434.74a6.94,6.94,0,0,0,3.31-3"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClientUploadSuccessV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Client_Upload_Success_v2.6db0fc80.svg";
export { ForwardRef as ReactComponent };